<template>
  <div>
    <div class="m10 fs24 fw500" v-if="showTitle">
      {{ inConfig.name }}
      <div v-if="inConfig.remarks" class="fs16" style="color: #909399">
        {{ inConfig.remarks }}
      </div>
    </div>

    <!-- 数据统计部分 -->
    <div class="kuai box-s ac wrap" v-if="page_data && page_data.statistics">
      <div v-for="(item, index) in page_data.statistics" :key="index">
        <span class="mr20"> {{ item.name }} {{ item.value }} </span>
      </div>
    </div>

    <!-- 搜索部分 -->
    <div class="kuai box-s ac wrap" v-if="inConfig.search_config && inConfig.search_config.length > 0" :key="search_key">
      <div v-for="(item, index) in inConfig.search_config" :key="index" class="mr20 mb10 ac">
        <div class="mr4 fs14" style="white-space: nowrap">{{ item.title }}:</div>
        <div v-if="item.type == '按钮单选'">
          <el-radio-group v-model="post_data[item.key]" size="medium" @change="inputSearch">
            <el-radio-button :label="option.name" v-for="(option, index) in item.content" :key="index"></el-radio-button>
          </el-radio-group>
        </div>

        <div v-else-if="item.type == '下拉单选'">
          <!-- post_data[item.key] -->
          <XSelect v-model="post_data[item.key]" :api="item.default" :key="index" @change="inputSearch" />
        </div>

        <div v-else-if="item.type == '日期时间'">
          <el-date-picker v-model="post_data[item.key]" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
        </div>
        <div v-else-if="item.type == '开始结束时间'">
          <el-date-picker
            v-model="post_data[item.key]"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <el-input v-model="post_data[item.key]" @change="inputSearch" v-else placeholder="请输入"></el-input>
      </div>
      <div>
        <el-button type="success" @click="Search">查询</el-button>
        <el-button plain @click="resetSearch">重置</el-button>
      </div>
    </div>
    <!-- 表格主体 -->

    <div class="p20" v-if="page_data">
      <el-table :data="page_data.items" stripe style="width: 100%" @sort-change="sortChange" @selection-change="handleSelectionChange">
        <!-- 默认的id -->
        <el-table-column type="selection" width="55" v-if="select"> </el-table-column>
        <el-table-column prop="id" label="id" width="60" sortable v-if="page_data.items && page_data.items.length > 0 && page_data.items[0].id"></el-table-column>
        <!-- 自定义的内容显示 -->

        <el-table-column :prop="item.key" :label="item.title" v-for="(item, index) in inConfig.table_config" :key="index" :sortable="item.key == 'balance' ? 'custom' : item.order" :width="item.width">
          <template slot-scope="scope">
            <!-- 如果是数据显示 -->
            <div v-if="item.row_type == ''">
              <div v-if="item.content.show_type == 'avatar'">
                <img :src="scope.row[item.key]" class="avatar box-s" alt="" v-if="scope.row[item.key] && scope.row[item.key] != ''" />
              </div>
              <div v-else-if="item.content.show_type == 'user'">
                <XAdminUserInfo v-model="scope.row[item.key]" :key="scope.row.id" />
              </div>
              <div v-else-if="item.content.show_type == 'admin'">
                <XAdminInfo v-model="scope.row[item.key]" />
              </div>
              <div v-else-if="item.content.show_type == 'workInfo'">
                <XWorkInfo v-model="scope.row[item.key]" />
              </div>
              <div v-else-if="item.content.show_type == 'project'">
                <XAdminProject v-model="scope.row[item.key]" />
              </div>
              <div v-else>
                <div v-if="scope.row[item.key] == '在线'" style="color: #67c23a" class="fw600">
                  {{ scope.row[item.key] }}
                </div>
                <div v-else-if="scope.row[item.key] == '离线'" style="color: #e6a23c" class="fw600">
                  {{ scope.row[item.key] }}
                </div>
                <div v-else-if="scope.row[item.key] == '离职'" style="color: #f56c6c" class="fw600">
                  {{ scope.row[item.key] }}
                </div>

                <div v-else @click="copyText(scope.row[item.key])">
                  {{ scope.row[item.key] }}
                </div>
                <!-- {{ item.content.show_type }} -->
              </div>
            </div>
            <!-- 如果是开关 -->
            <div v-else-if="item.row_type == 'switch'">
              <el-switch v-model="scope.row[item.key]" @change="event_func(scope.row, item.content.event)"></el-switch>
            </div>
            <!-- 条件按钮 -->
            <div v-else-if="item.row_type == 'ifBtn'">
              <div v-if="item.content.condition == 'has' && scope.row[item.content.key]">
                <el-button class="mb2" :type="item.content.type" size="mini" @click="event_func(scope.row, item.content.event)">{{ item.content.name }}</el-button>
              </div>
              <div v-if="item.content.condition == 'not' && !scope.row[item.content.key]">
                <el-button class="mb2" :type="item.content.type" size="mini" @click="event_func(scope.row, item.content.event)">{{ item.content.name }}</el-button>
              </div>
              <div v-if="item.content.condition == '==' && scope.row[item.content.key] == item.content.condition_key">
                <el-button class="mb2" :type="item.content.type" size="mini" @click="event_func(scope.row, item.content.event)">{{ item.content.name }}</el-button>
              </div>
              <div v-if="item.content.condition == '!=' && scope.row[item.content.key] != item.content.condition_key">
                <el-button class="mb2" :type="item.content.type" size="mini" @click="event_func(scope.row, item.content.event)">{{ item.content.name }}</el-button>
              </div>
            </div>
            <!-- 条件按钮组 -->
            <div v-else-if="item.row_type == 'ifBtns'">
              <div v-for="(btn, bindex) in item.content.data" :key="bindex">
                <div v-if="btn.condition == 'has' && scope.row[btn.key]">
                  <el-button class="mb2" :type="btn.type" size="mini" @click="event_func(scope.row, btn.event)">{{ btn.name }}</el-button>
                </div>
                <div v-if="btn.condition == 'not' && !scope.row[btn.key]">
                  <el-button class="mb2" :type="btn.type" size="mini" @click="event_func(scope.row, btn.event)">{{ btn.name }}</el-button>
                </div>
                <div v-if="btn.condition == '==' && scope.row[btn.key] == btn.condition_key">
                  <el-button class="mb2" :type="btn.type" size="mini" @click="event_func(scope.row, btn.event)">{{ btn.name }}</el-button>
                </div>
                <div v-if="btn.condition == '!=' && scope.row[btn.key] != btn.condition_key">
                  <el-button class="mb2" :type="btn.type" size="mini" @click="event_func(scope.row, btn.event)">{{ btn.name }}</el-button>
                </div>
              </div>
            </div>

            <!-- 如果是按钮组 -->
            <div v-else-if="item.row_type == 'btns'">
              <div v-for="(btn, btnIndex) in item.content.data" :key="btnIndex">
                <el-button class="mb2" :type="btn.type" size="mini" @click="event_func(scope.row, btn.event)">{{ btn.name }}</el-button>
              </div>
            </div>
            <!-- 如果是按钮 -->
            <div v-else-if="item.row_type == 'btn'">
              <el-button class="mb2" :type="item.content.type" size="mini" @click="event_func(scope.row, item.content.event)">{{ item.content.name }}</el-button>
            </div>
            <div v-else-if="item.row_type == 'input'">
              <el-input v-model="scope.row[item.key]" placeholder="请输入"></el-input>
            </div>

            <div v-else>
              {{ item.row_type }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页功能 -->
    <div class="m20" v-if="page_data">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="post_data.page"
        :page-sizes="[10, 20, 100, 200, 300, 400]"
        :page-size="post_data.per_page"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page_data.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {http_post} from '@/api/api'

  export default {
    props: {
      inConfig: {
        type: [Array, Object],
        default: () => null
      },
      defaultConfig: {
        // 默认的搜索条件
        type: [Array, Object],
        default: () => null
      },
      showTitle: {
        type: Boolean,
        default: true
      },
      select: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        search_key: 0,
        post_data: null,
        page_data: null,
        search_config: {
          page: 1,
          per_page: 10
        },
        pickerOptions: {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      }
    },

    created() {
      if (this.inConfig.search_config) {
        this.inConfig.search_config.forEach(item => {
          if (!item.type) {
            this.search_config[item.key] = ''
          } else if (item.type == 'radio-btn' || item.type == 'radio') {
            this.search_config[item.key] = item.options[0]
          }
          // console.log(item)
          if (item.default && item.type != '下拉单选') {
            this.search_config[item.key] = item.default
          }
          if (item.type == '下拉单选') {
            this.search_config[item.key] = ''
          }
        })
      }

      if (this.defaultConfig) {
        Object.keys(this.defaultConfig).forEach(key => {
          this.search_config[key] = this.defaultConfig[key]
        })
      }

      this.post_data = JSON.parse(JSON.stringify(this.search_config))
      this.Search()
    },

    methods: {
      copyText(text) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success('文本已复制')
          })
          .catch(err => {
            this.$message.error('复制失败')
          })
      },
      handleSelectionChange(e) {
        this.$emit('select', e)
      },
      event_func(row, e) {
        if (e == 'save') {
          this.update_func(row)
        } else if (e == 'del') {
          this.del_func(row)
        } else {
          this.$emit('event', {row: row, event: e})
        }
      },

      del_func(item) {
        this.$confirm('确认删除？')
          .then(_ => {
            http_post(this.inConfig.del_api, {id: item.id}).then(res => {
              if (res.code == 200) {
                this.Search()
              }
            })
          })
          .catch(_ => {})
      },
      inputSearch() {
        this.post_data.page = 1
        this.Search()
      },
      update_func(item) {
        http_post(this.inConfig.update_api, item).then(res => {
          this.Search()
        })
      },

      // 重置搜索
      resetSearch() {
        this.search_key += 1
        this.post_data = JSON.parse(JSON.stringify(this.search_config))
        this.Search()
      },
      // 分页相关
      Search() {
        http_post(this.inConfig.list_api, this.post_data).then(res => {
          // console.log(res)
          this.page_data = res.data
          if (res.data.per_page == 1) {
            this.post_data.per_page = res.data.total
          }
        })
      },
      // 每页x条
      sizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.post_data.per_page = val
        this.Search()
      },
      //跳转某页
      currentChange(val) {
        // console.log(`当前页: ${val}`)
        this.post_data.page = val
        this.Search()
      },
      // 修改排序
      sortChange(column) {
        this.post_data.prop = column.prop
        this.post_data.order = column.order
        this.post_data.page = 1
        this.Search()
      }
    }
  }
</script>

<style lang="scss" scoped></style>
